var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgPgMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_858",
    "data-name": "Group 858",
    transform: "translate(8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6124",
    "data-name": "Group 6124",
    transform: "translate(-8)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_127",
    "data-name": "Ellipse 127",
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#0070b6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Safe_and_secure_transactions",
    "data-name": "Safe and secure transactions",
    transform: "translate(6.4 6.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M0,0H19.2V19.2H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Optimized_for_web_and_mobile",
    "data-name": "Optimized for web and mobile",
    transform: "translate(1.6 1.089)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6-2",
    "data-name": "Path 6",
    d: "M0,0H16V16H0Z",
    transform: "translate(0 0.667)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "important_devices-24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M0,0H16V16H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M15.333,8.007,12,8a.669.669,0,0,0-.667.667v6a.669.669,0,0,0,.667.667h3.333A.669.669,0,0,0,16,14.667v-6A.663.663,0,0,0,15.333,8.007ZM14.984,14H12.37V9.333h2.615ZM13.333,2h-12A1.329,1.329,0,0,0,0,3.333v8a1.333,1.333,0,0,0,1.333,1.333H6.667V14h-2v1.333H10V14H8V12.667h2V11.333H1.333v-8h12V6.667h1.333V3.333A1.333,1.333,0,0,0,13.333,2Z",
    transform: "translate(0.8 0.133)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1979",
    "data-name": "Path 1979",
    d: "M15.333,8.007,12,8a.669.669,0,0,0-.667.667v6a.669.669,0,0,0,.667.667h3.333A.669.669,0,0,0,16,14.667v-6A.663.663,0,0,0,15.333,8.007ZM14.984,14H12.37V9.333h2.615ZM13.333,2h-12A1.329,1.329,0,0,0,0,3.333v8a1.333,1.333,0,0,0,1.333,1.333H6.667V14h-2v1.333H10V14H8V12.667h2V11.333H1.333v-8h12V6.667h1.333V3.333A1.333,1.333,0,0,0,13.333,2Z",
    transform: "translate(0 -0.667)",
    fill: "#fff"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPgMobile);
export default __webpack_public_path__ + "static/media/pg-mobile.eec5056bbc5e13e7819373e3fdd619fd.svg";
export { ForwardRef as ReactComponent };